import * as React from 'react';
import {Spinner} from "./Spinner";

export interface ICoreState {
    isLoading: boolean;
    loadingNotification: JSX.Element;
    popupNotification: JSX.Element;
    errorNotification: JSX.Element;
}

const coreState: ICoreState = {
    isLoading: false,
    loadingNotification: <Spinner />,
    popupNotification: <div/>,
    errorNotification: <div/>
};

export default coreState;


// WEBPACK FOOTER //
// ./src/component/common/CoreState.tsx